@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.comboBoxContents {
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  padding-right: 12px;
  background: var(--light-100);
  box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);
  @include blur;

  @include for-phone-only {
    background: var(--dark-4);
  }

  &:focus-within {
    .prefixIcon {
      path {
        fill: $green-50;
      }
    }
  }

  &:hover {
    .prefixIcon,
    .postfixIcon {
      path {
        fill: $green-50;
      }
    }
  }

  [data-autopilot-system-redesign='on'] & {
    border-radius: 8px;
    box-shadow: none;
    border: 1px solid var(--dark-8);

    &:hover {
      border-color: var(--dark-15);
    }

    &:focus-within {
      border-color: var(--dark-80);
    }
  }
}

.input {
  background: transparent;
  @include line-clamp;
}

.prefixIconContainer {
  position: relative;
  padding-left: 8px;
  display: flex;
  align-items: center;
}

.prefixIcon {
  height: 14px;
  width: 14px;
  transition: all 0.3s;
  display: block;
}

.postfixIcon {
  position: absolute;
  top: 9px;
  right: 11px;
  margin-left: 14px;
  vertical-align: middle;
  height: 14px;
  width: 14px;

  &.pointer {
    cursor: pointer;
  }
}

.chevron {
  display: flex;
  align-items: center;
}

@media (min-width: $phoneMaxWidth) {
  .comboBoxContents {
    border: 1px solid var(--dark-15);
    box-shadow: none;
  }
}
